import React, { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Button from "../../components/Button";
import Input from "../../components/Input";
import companyIcon from "../../images/svg/companyIcon.svg";
import loginAdmIcon from "../../images/svg/loginAdmIcon.svg";
import ThowColumLayoutLogin from "../../layouts/ThowColumLayoutLogin";
import api from "../../services/api";

const LoginAdm = () => {
  const [mail, setMail] = useState();
  const [password, setPassword] = useState();
  const navigate = useNavigate();

  const [mailError, setMailError] = useState();
  const [paswordError, setPasswordError] = useState();
  const [btnState, setBtnState] = useState();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const autoLogin = async () => {
      const token = localStorage.getItem("@MAXITRANS_TOKEN_ADMIN:");
      if (!token) {
        setChecking(false);
        return;
      }
      try {
        const response = await api.get("/session/admin/validate");
        const { permission, token: newToken } = response.data;
        if (newToken) {
          localStorage.setItem("@MAXITRANS_TOKEN_ADMIN:", newToken);
        }
        if (permission !== "adm") {
          navigate("/dashboard/manage", { replace: true });
        } else {
          navigate("/dashboard", { replace: true });
        }
      } catch {
        localStorage.removeItem("@MAXITRANS_TOKEN_ADMIN:");
        setChecking(false);
      }
    };
    autoLogin();
  }, [navigate]);

  const validateEmail = (email) => {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
  };

  const onSubmitSession = async () => {
    if (!mail || !password) {
      return toast.error("Preencha os campos de e-mail e senha", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }

    if (!validateEmail(mail)) {
      return toast.error("Email inválido", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }

    const data = {
      email: mail,
      password: password,
    };

    setBtnState(true);
    try {
      const response = await api.post("/session/admin", data);

      const { token, permission } = response.data;
      localStorage.removeItem("@MAXITRANS_TOKEN_CLIENT:");
      localStorage.removeItem("@MAXITRANS_TOKEN_ADMIN:");

      localStorage.setItem("@MAXITRANS_TOKEN_ADMIN:", token);

      if (permission !== "adm") {
        navigate("/dashboard/manage", { replace: true });
      } else {
        navigate("/dashboard", { replace: true });
      }
    } catch (error) {
      if (!error?.response?.status) {
        toast.warn(
          `Desculpe, parece que estamos enfrentando problemas técnicos no momento. Por favor, entre em contato com nossa equipe de suporte.`,
          {
            position: "top-right",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          }
        );
      } else {
        toast.error(error?.response?.data?.error || error.message, {
          position: "top-right",
          autoClose: 2500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    } finally {
      setBtnState(false);
    }
  };

  if (checking) return null;

  return (
    <ThowColumLayoutLogin
      page={"Landing"}
      colum1={
        <div className="login-image-container">
          <img src={loginAdmIcon} className="login-image" alt="Login illustration" />
        </div>
      }
      colum2={
        <div className="login-form-container">
          <img src={companyIcon} alt="Maxitrans logo" />

          <div className="login-form-inner">
            <h2 className="textPrimaryLoginAdm">Acesso administrativo</h2>

            <Input
              name="E-mail"
              error={mailError}
              onChange={(e) => setMail(e.target.value)}
              onKeyBoard={onSubmitSession}
              placeholder="Insira seu e-mail"
              type={"email"}
            />
            <Input
              name="Senha"
              error={paswordError}
              onChange={(e) => setPassword(e.target.value)}
              onKeyBoard={onSubmitSession}
              placeholder="Insira sua senha"
              type={"password"}
            />

            <div className="login-btn-row">
              <Button
                width="185px"
                height="48px"
                background="#123164"
                borderRadius="60px"
                marginTop="0"
                name="Entrar"
                border="none"
                disabled={btnState}
                onClick={() => onSubmitSession()}
              />
            </div>
          </div>
        </div>
      }
    />
  );
};

export default LoginAdm;
